<div class="renovate-contract-pymes-resume">
  <div class="renovate-contract-pymes-resume__header">
    <h2>{{ 'RENOVATE_COTRACT.TITLE' | i18nextEager }}</h2>
    <span>
      <img src="/assets/icons/close.svg" (click)="closeDialog()" alt="{{ 'COMMONS.CLOSE' | i18nextEager }}" />
    </span>
  </div>
  <div class="renovate-contract-pymes-resume__steps">
    <div class="renovate-contract-pymes-resume__step" (click)="handleTabCampaign()">
      <h2>{{ 'NEW_CONTRACTS.RESUME_DIALOG.RISK_CAMPAIGN' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: tabCampaign }" />
      </span>
    </div>
    <div *ngIf="tabCampaign">
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.CUPS' | i18nextEager }}</h3>
        <span>{{ data?.campaign?.cups }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.CIF' | i18nextEager }}</h3>
        <span>{{ data?.campaign?.cif }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.CONSUMPTION' | i18nextEager }}</h3>
        <span>{{ data?.campaign?.estimateConsuption }} <strong>kWh</strong></span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.CAMPAIGN' | i18nextEager }}</h3>
        <span>{{ data?.campaign?.campaignLabel }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.LEVEL' | i18nextEager }}</h3>
        <span>{{ data?.campaign?.levelLabel }}</span>
      </div>
    </div>
    <div class="renovate-contract-pymes-resume__step" (click)="handleTabSocialReason()">
      <h2>{{ 'NEW_CONTRACTS.RESUME_DIALOG.BUSINESS' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: tabSocialReason }" />
      </span>
    </div>
    <div *ngIf="tabSocialReason">
      <div class="renovate-contract-pymes-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACTS.MAIN_DATA' | i18nextEager }}</h3>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.BUSINESS' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.name }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.CIF' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.cif }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.CNAE' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.cnae }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACTS.RESUME_DIALOG.CONTACT_DATA' | i18nextEager }}</h3>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.NAME' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.nameContact }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.SURNAME' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.surnameContact }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.DNI' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.dniContact }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.EMAIL' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.emailContact }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.MOBILE' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.phoneContact }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACTS.ADDRESS' | i18nextEager }}</h3>
      </div>
      <div *ngIf="data?.socialReason?.viaType" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_TYPE' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.viaType }}</span>
      </div>
      <div *ngIf="data?.socialReason?.roadName" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.roadName }}</span>
      </div>
      <div *ngIf="data?.socialReason?.number && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.number }}</span>
      </div>
      <div *ngIf="data?.socialReason?.gate && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.gate }}</span>
      </div>
      <div *ngIf="data?.socialReason?.stair && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.stair }}</span>
      </div>
      <div *ngIf="data?.socialReason?.floor && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.floor }}</span>
      </div>
      <div *ngIf="data?.socialReason?.door && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.door }}</span>
      </div>
      <div *ngIf="data?.socialReason?.postalCode" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.postalCode }}</span>
      </div>
      <div *ngIf="data?.socialReason?.town" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</h3>
        <span>{{ data?.socialReason?.town }}</span>
      </div>
    </div>
    <div class="renovate-contract-pymes-resume__step" (click)="handleTabInstallation()">
      <h2>{{ 'NEW_CONTRACTS.RESUME_DIALOG.ISTALLATION_DATA' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: tabInstallation }" />
      </span>
    </div>
    <div *ngIf="tabInstallation">
      <div class="renovate-contract-pymes-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACTS.MAIN_DATA' | i18nextEager }}</h3>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.INSTALLATION_NAME' | i18nextEager }}</h3>
        <span>{{ data?.installation?.name }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.CUPS' | i18nextEager }}</h3>
        <span>{{ data?.installation?.cups }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.ACCESS_FEE' | i18nextEager }}</h3>
        <span>{{ data?.installation?.feeLabel }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACTS.ADDRESS' | i18nextEager }}</h3>
      </div>
      <div *ngIf="data?.installation?.viaType" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_TYPE' | i18nextEager }}</h3>
        <span>{{ data?.installation?.viaType }}</span>
      </div>
      <div *ngIf="data?.installation?.roadName" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</h3>
        <span>{{ data?.installation?.roadName }}</span>
      </div>
      <div *ngIf="data?.installation?.number && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</h3>
        <span>{{ data?.installation?.number }}</span>
      </div>
      <div *ngIf="data?.installation?.gate && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</h3>
        <span>{{ data?.installation?.gate }}</span>
      </div>
      <div *ngIf="data?.installation?.stair && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</h3>
        <span>{{ data?.installation?.stair }}</span>
      </div>
      <div *ngIf="data?.installation?.floor && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</h3>
        <span>{{ data?.installation?.floor }}</span>
      </div>
      <div *ngIf="data?.installation?.door && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</h3>
        <span>{{ data?.installation?.door }}</span>
      </div>
      <div *ngIf="data?.installation?.postalCode" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</h3>
        <span>{{ data?.installation?.postalCode }}</span>
      </div>
      <div *ngIf="data?.installation?.town" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</h3>
        <span>{{ data?.installation?.town }}</span>
      </div>
    </div>
    <div class="renovate-contract-pymes-resume__step" (click)="handleTabPayment()">
      <h2>{{ 'NEW_CONTRACTS.RESUME_DIALOG.PAYMENT_DATA' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: tabPayment }" />
      </span>
    </div>
    <div *ngIf="tabPayment">
      <div class="renovate-contract-pymes-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACTS.NOTIFICATION_ADDRESS' | i18nextEager }}</h3>
      </div>
      <div *ngIf="data?.contract?.viaType" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_TYPE' | i18nextEager }}</h3>
        <span>{{ data?.contract?.viaType }}</span>
      </div>
      <div *ngIf="data?.contract?.roadName" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</h3>
        <span>{{ data?.contract?.roadName }}</span>
      </div>
      <div *ngIf="data?.contract?.number && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</h3>
        <span>{{ data?.contract?.number }}</span>
      </div>
      <div *ngIf="data?.contract?.gate && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</h3>
        <span>{{ data?.contract?.gate }}</span>
      </div>
      <div *ngIf="data?.contract?.stair && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</h3>
        <span>{{ data?.contract?.stair }}</span>
      </div>
      <div *ngIf="data?.contract?.floor && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</h3>
        <span>{{ data?.contract?.floor }}</span>
      </div>
      <div *ngIf="data?.contract?.door && isUserSpanish" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</h3>
        <span>{{ data?.contract?.door }}</span>
      </div>
      <div *ngIf="data?.contract?.postalCode" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</h3>
        <span>{{ data?.contract?.postalCode }}</span>
      </div>
      <div *ngIf="data?.contract?.townLabel" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</h3>
        <span>{{ data?.contract?.townLabel }}</span>
      </div>
      <div class="renovate-contract-pymes-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACTS.SIGNATURE_DATA' | i18nextEager }}</h3>
      </div>
      <div *ngIf="data?.contract?.nameSigner" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.NAME' | i18nextEager }}</h3>
        <span>{{ data?.contract?.nameSigner }}</span>
      </div>
      <div *ngIf="data?.contract?.surnameSigner" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.SURNAME' | i18nextEager }}</h3>
        <span>{{ data?.contract?.surnameSigner }}</span>
      </div>
      <div *ngIf="data?.contract?.dniSigner" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.DNI' | i18nextEager }}</h3>
        <span>{{ data?.contract?.dniSigner }}</span>
      </div>
      <div *ngIf="data?.contract?.emailSigner" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.EMAIL' | i18nextEager }}</h3>
        <span>{{ data?.contract?.emailSigner }}</span>
      </div>
      <div *ngIf="data?.contract?.phoneSigner" class="renovate-contract-pymes-resume__content">
        <h3>{{ 'NEW_CONTRACTS.MOBILE' | i18nextEager }}</h3>
        <span>{{ data?.contract?.phoneSigner }}</span>
      </div>
      <ng-container
        *ngIf="
          data?.contract?.iban ||
          data?.contract?.entity ||
          data?.contract?.office ||
          data?.contract?.dc ||
          data?.contract?.account
        "
      >
        <div class="renovate-contract-pymes-resume__content">
          <h3 class="black">{{ 'NEW_CONTRACTS.BANK_ACCOUNT' | i18nextEager }}</h3>
        </div>
        <div class="renovate-contract-pymes-resume__content">
          <h3></h3>
          <span>
            {{ data?.contract?.iban }} {{ data?.contract?.entity }} {{ data?.contract?.office }}
            {{ data?.contract?.dc }}
            {{ data?.contract?.account }}
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
